import React from "react";
import times from "lodash.times";
import Img from "gatsby-image";

import styles from "./Hero.module.css";

const Hero = ({
  pageTitle,
  heroImage,
  heroAlt,
  videoSrcHevc,
  videoSrcWebm,
  videoSrcMp4,
  videoPoster,
}) => {
  return (
    <div className={styles.Hero}>
      {heroImage ? (
        <Img className={styles.HeroImage} alt={heroAlt} fluid={heroImage} />
      ) : (
        <div className={styles.HeroVideo}>
          {/**
           * React does not guarantee that muted attribute will be set
           * in the actual DOM so we use `dangerouslySetInnerHtml` to
           * circumvent this issue.
           * Codecs supported:
           * H265 (HEVC): High quality codec for MacOS and iOS
           * VP9 (WebM): High quality codec for Android and Chrome
           * H264: Fallback for old browsers and operative systems.
           */}
          <div
            className={styles.HeroVideoWrapper}
            dangerouslySetInnerHTML={{
              __html: `
            <video autoPlay muted loop playsinline poster="${videoPoster}">
              <source src="${videoSrcHevc}" type="video/mp4; codecs="hevc" />
              <source src="${videoSrcWebm}" type="video/webm; codecs="vp9" />
              <source src="${videoSrcMp4}" type="video/mp4" />
            </video>`,
            }}
          />
        </div>
      )}
      <div className={styles.HeroHeadingMarquee}>
        <h1 className={styles.HeroHeadingMarqueeInner}>
          {times(4, (i) => (
            <p key={i}>{pageTitle}</p>
          ))}
        </h1>
      </div>
    </div>
  );
};

export default Hero;
